import { type FlowInformationExtractionBlockConfig } from 'flow-schema';
import * as uuid from 'uuid';

import { LlmModelName } from 'llm-model-registry';

function getDefaultInformationExtractionFieldConfig() {
  return {
    id: uuid.v4(),
    name: '',
    description: '',
  };
}

export function getDefaultInformationExtractionConfig(): FlowInformationExtractionBlockConfig {
  return {
    documents: '',
    extractionFields: [getDefaultInformationExtractionFieldConfig()],
    examples: [],
    additionalPrompt: '',
    rankingPrompt: '',
    modelName: LlmModelName.notable_default,
  };
}
